const KEY = 'tc_referral_code';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

interface StoredReferral {
  code: string;
  expiresAt: number;
}

export function setReferralCode(code: string): void {
  if (typeof window === 'undefined') return;
  const trimmed = code.trim();
  if (!trimmed) return;
  try {
    const payload: StoredReferral = { code: trimmed, expiresAt: Date.now() + TTL_MS };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch (err) {
    console.warn('[referralStorage] Failed to persist code:', err);
  }
}

export function getReferralCode(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;

    const parsed = JSON.parse(raw) as StoredReferral;
    if (!parsed?.code || typeof parsed.expiresAt !== 'number') return undefined;
    if (Date.now() > parsed.expiresAt) {
      localStorage.removeItem(KEY);
      return undefined;
    }
    return parsed.code;
  } catch (err) {
    console.warn('[referralStorage] Failed to read code:', err);
    return undefined;
  }
}

export function clearReferralCode(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    console.warn('[referralStorage] Failed to clear code:', err);
  }
}
